import React, { FC } from 'react';
import { DataGridToolbarFullProps } from './DataGridToolbarFullProps';
import CustomDatagridToolbar from '../CustomDatagridToolbar';

const DataGridToolbarFull: FC<DataGridToolbarFullProps> = ({
  handleStorage,
  handleReset,
}) => {
  return (
    <CustomDatagridToolbar
      handleStorage={handleStorage}
      handleReset={handleReset}
      exportButton
      columnsButton
      filterButton
    />
  );
};

export default DataGridToolbarFull;
